<template>
	<div class="page-header">
		<div class="hero">
			<img :src="hero" />
		</div>
		<div class="discussion-overview-wrap">
			<section class="discussion-overview">
				<div class="title-wrap">
					<h2>
						{{ title }}
					</h2>
				</div>
				<div class="head-set">
					<div class="head-title">
						<h3 class="page-title">
							<img :src="image" v-bind:alt="alt" class="over_display" />
							<img :src="imageSp" v-bind:alt="alt" class="under_display" />
						</h3>
						<div class="head-intro-wrap">
							<div class="head-intro">
								<div class="intro" v-html="intro"></div>
							</div>
						</div>
					</div>
				</div>
				<slot />
			</section>
			<p class="attention">※入社年数および年齢はインタビュー当時のものです</p>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
// import News from '@/components/News.vue';
export default {
	name: 'page-header',
	props: {
		hero: String,
		title: String,
		image: String,
		imageSp: String,
		alt: String,
		intro: String,
	},
};
</script>

<style lang="scss" scoped>
.discussion_young {
	position: relative;
	margin-bottom: 50px;
}
.page-header {
	margin: 0 auto;
	@media print, screen and (max-width: 1160px) {
		max-width: 90%;
	}
}
.hero {
	img {
		vertical-align: middle;
	}
}
.discussion-overview-wrap {
	max-width: 1000px;
	width: 100%;
	background-color: #fff;
	margin: 0 auto;
	position: relative;
	padding-bottom: 50px;
	@media print, screen and (min-width: 1161px) {
		margin-top: 100px;
	}
}
.discussion-overview {
	margin: 0 auto;
	@media print, screen and (max-width: 1160px) {
		max-width: 90%;
	}
}
.title-wrap {
	font-family: 'Noto Serif JP', serif;
	top: 0px;
	background-color: #543193;
	color: #fff;
	margin: 0;
	position: relative;
	@media print, screen and (min-width: 1161px) {
		margin-left: 50px;
		display: inline-block;
		margin-top: 50px;
	}
	@media print, screen and (max-width: 1160px) {
		font-size: 13px;
		top: -10px;
	}
	h2 {
		margin: 0;
		padding: 0 3em;
		text-align: center;
		position: relative;
		line-height: 2em;
		&:before {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			left: 0;
		}
		&:after {
			content: '';
			width: 15px;
			height: 2px;
			display: block;
			background-color: #fff;
			top: calc(50% - 2px);
			position: absolute;
			right: 0;
		}
	}
}
.head-set {
	max-width: 920px;
	width: 100%;
	position: relative;
	margin: 0 auto;
	margin-top: 150px;
	margin-bottom: 100px;
	@media print, screen and (max-width: 1160px) {
		margin-top: 50px;
		margin-bottom: 30px;
	}
}
.head-title {
	position: relative;
}
.page-title {
	position: relative;
	top: 0;
	width: 100%;
	z-index: 0;
}
.head-intro-wrap {
	display: flex;
	justify-content: center;
	position: relative;
}
.head-intro {
	// top: 0;
	// transform: translateX(-50%);
	// left: 50%;
	// position: absolute;
}
.head-catch {
	font-family: 'Noto Serif JP', serif;
	font-size: 45px;
	margin: 0;
	margin-top: -1em;
	@media print, screen and (min-width: 1161px) {
		white-space: nowrap;
	}
	@media print, screen and (max-width: 1160px) {
		font-size: 18px;
	}
}
.intro {
	font-size: 14px;
	margin-top: 50px;
	line-height: 3em;
	@media print, screen and (max-width: 1160px) {
		line-height: 2em;
	}
}
.attention {
	text-align: right;
	font-size: 14px;
	max-width: 920px;
	width: 90%;
	margin: 0 auto;
	margin-top: 50px;
	@media print, screen and (max-width: 1160px) {
		text-align: left;
	}
}
</style>
